export const FEATURE_NAMES = {
  FANCAM_LIVE: {
    en: 'FanCam React',
    ja: 'ファンカムリアクト'
  }
};
